var React = require('react');

function UiMinusThick (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Minus Thick"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M30,3.5C30,5.4,28.4,7,26.5,7h-23C1.6,7,0,5.4,0,3.5S1.6,0,3.5,0h23C28.4,0,30,1.6,30,3.5L30,3.5z"})))]);
}

UiMinusThick.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 30 7","style":{"enableBackground":"new 0 0 30 7"},"xmlSpace":"preserve"};

module.exports = UiMinusThick;

UiMinusThick.default = UiMinusThick;
